/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React from "react";
import { ERROR_ICON } from "../../config.json";

function ErrorPage() {
  return (
    <main className="flex-shrink-0 without-left-menu m-0">
      <div className="container-fluid">
        <div className="row align-items-center content-block__empty-row p-1 rounded text-center">
          <div className="col-lg-12 mt-n5">
            <img className="image-error" src={ERROR_ICON} />
            <h1 className="font-weight-bold">Ooops!</h1>
            <p className="sub-text">
              Something went wrong. Refresh your page and try again!
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default ErrorPage;
